import React from "react";
import { Route, Navigate } from "react-router-dom";

const routes = all_routes;
//region Icons
import FontawesomeIcons from "../feature-module/uiinterface/icons/fontawesome";
import FeatherIcons from "../feature-module/uiinterface/icons/feathericon";
import IonicIcons from "../feature-module/uiinterface/icons/ionicicons";
import MaterialIcons from "../feature-module/uiinterface/icons/materialicon";
import PE7Icons from "../feature-module/uiinterface/icons/pe7icons";
import SimplelineIcons from "../feature-module/uiinterface/icons/simplelineicon";
import ThemifyIcons from "../feature-module/uiinterface/icons/themify";
import WeatherIcons from "../feature-module/uiinterface/icons/weathericons";
import TypiconIcons from "../feature-module/uiinterface/icons/typicons";
import FlagIcons from "../feature-module/uiinterface/icons/flagicons";
import BootstrapIcons from "../feature-module/uiinterface/icons/bootstrapicons";
import RemixIcons from "../feature-module/uiinterface/icons/remixIcons";
import TablerIcon from "../feature-module/uiinterface/icons/tablericon";

import Signin from "../feature-module/pages/login/signin";

import Forgotpassword from "../feature-module/pages/forgotpassword/forgotpassword";

import { all_routes } from "./all_routes";

import LayoutDemo from "../feature-module/layout-pages/layoutdemo";

//region CRM
import CRMDashboard from "../feature-module/Pereco/CRM/Dashboard/Dashboard";
import CRMContacts from "../feature-module/Pereco/CRM/Customers/CRMContacts";
import CRMCustomers from "../feature-module/Pereco/CRM/Customers/Customers";
import CRMInvoices from "../feature-module/Pereco/CRM/Sales/Invoices/Invoices";
import CRMTasks from "../feature-module/Pereco/CRM/Tasks/Tasks";
import Estimates from "../feature-module/Pereco/CRM/Sales/Estimates/Estimates";
import CreateNewEstimate from "../feature-module/Pereco/CRM/Sales/Estimates/CreateNewEstimate";
import Proposals from "../feature-module/Pereco/CRM/Sales/Proposals/Proposals";
import CreateProposalForm from "../feature-module/Pereco/CRM/Sales/Proposals/CreateProposal";
import EditProposalForm from "../feature-module/Pereco/CRM/Sales/Proposals/EditProposal";
import ViewProposal from "../feature-module/Pereco/CRM/Sales/Proposals/ViewProposal";
import EditEstimate from "../feature-module/Pereco/CRM/Sales/Estimates/EditEstimate";
import ViewEstimate from "../feature-module/Pereco/CRM/Sales/Estimates/ViewEstimate";
import NewInvoice from "../feature-module/Pereco/CRM/Sales/Invoices/NewInvoice";
import Editinvoice from "../feature-module/Pereco/CRM/Sales/Invoices/Editinvoice";
import CRMExpenses from "../feature-module/Pereco/CRM/Expenses/Expenses";
import ProposalInfo from "../feature-module/Pereco/CRM/Sales/Proposals/ProposalInfo";
import EstimateInfo from "../feature-module/Pereco/CRM/Sales/Estimates/EstimateInfo";
import ExpenseInfo from "../feature-module/Pereco/CRM/Expenses/ExpenseInfo";
import Payments from "../feature-module/Pereco/CRM/Sales/Payments/Payments";
import ViewPayments from "../feature-module/Pereco/CRM/Sales/Payments/ViewPayments";
import CreditNotes from "../feature-module/Pereco/CRM/Sales/CreditNotes/CreditNotes";
import NewCreditNote from "../feature-module/Pereco/CRM/Sales/CreditNotes/NewCreditNote";
import CreditNoteInfo from "../feature-module/Pereco/CRM/Sales/CreditNotes/CreditNoteInfo";
import Leads from "../feature-module/Pereco/CRM/Leads/Leads";
import CRMTickets from "../feature-module/Pereco/CRM/Support/Tickets";
import ViewLeads from "../feature-module/Pereco/CRM/Leads/ViewLeads";
import CustomerInfo from "../feature-module/Pereco/CRM/Customers/CustomerInfo/CustomerInfo";
import NewTicket from "../feature-module/Pereco/CRM/Support/NewTicket";
import CRMProjects from "../feature-module/Pereco/CRM/Projects/Projects";
import CRMProducts from "./../feature-module/Pereco/CRM/Products/Products";
import ViewInvoice from "../feature-module/Pereco/CRM/Sales/Invoices/ViewInvoice";
import EditExpense from "../feature-module/Pereco/CRM/Expenses/EditExpenses";
import ProjectView from "../feature-module/Pereco/CRM/Projects/ProjectView";
import SigninTwo from "../feature-module/pages/login/signinTwo";
import SigninThree from "../feature-module/pages/login/signinThree";
import EditCreditNote from "../feature-module/Pereco/CRM/Sales/CreditNotes/EditCreditNote";
import Add from "../feature-module/Pereco/CRM/Sales/DynamicScreen/Add";
import View from "../feature-module/Pereco/CRM/Sales/DynamicScreen/View";
import Update from "../feature-module/Pereco/CRM/Sales/DynamicScreen/Update";
import Reports from "../feature-module/Pereco/CRM/Reports/Reports";
import Notify from "../feature-module/Pereco/CRM/Notifications/Notify";
import SqlQuery from "../feature-module/Pereco/CRM/SuperAdmin/SqlQueries/SqlQuery";
import Campaign from "../feature-module/Pereco/CRM/Campaign/Campaign";
import MessageHub from "../feature-module/Pereco/CRM/Notifications/MessageHub";

export const publicRoutes = [
  {
    id: 49,
    path: routes.fontawesome,
    name: "fontawesome",
    element: <FontawesomeIcons />,
    route: Route,
  },
  {
    id: 50,
    path: routes.feathericon,
    name: "feathericon",
    element: <FeatherIcons />,
    route: Route,
  },
  {
    id: 51,
    path: routes.ionicicons,
    name: "ionicicons",
    element: <IonicIcons />,
    route: Route,
  },
  {
    id: 52,
    path: routes.materialicons,
    name: "materialicons",
    element: <MaterialIcons />,
    route: Route,
  },
  {
    id: 53,
    path: routes.pe7icons,
    name: "pe7icons",
    element: <PE7Icons />,
    route: Route,
  },
  {
    id: 54,
    path: routes.simpleline,
    name: "simpleline",
    element: <SimplelineIcons />,
    route: Route,
  },
  {
    id: 55,
    path: routes.themifyicons,
    name: "themifyicon",
    element: <ThemifyIcons />,
    route: Route,
  },
  {
    id: 56,
    path: routes.iconweather,
    name: "iconweather",
    element: <WeatherIcons />,
    route: Route,
  },
  {
    id: 57,
    path: routes.typicons,
    name: "typicons",
    element: <TypiconIcons />,
    route: Route,
  },
  {
    id: 58,
    path: routes.flagicons,
    name: "flagicons",
    element: <FlagIcons />,
    route: Route,
  },
  {
    id: 106,
    path: routes.remixIcon,
    name: "remixIcon",
    element: <RemixIcons />,
    route: Route,
  },
  {
    id: 107,
    path: routes.BootstrapIcon,
    name: "BootstrapIcon",
    element: <BootstrapIcons />,
    route: Route,
  },
  {
    id: 108,
    path: routes.TablerIcon,
    name: "TablerIcon",
    element: <TablerIcon />,
    route: Route,
  },
  {
    id: 116,
    path: "*",
    name: "NotFound",
    element: <Navigate to="/" />,
    route: Route,
  },
  {
    id: 117,
    path: "/",
    name: "Root",
    element: <Navigate to="/signinThree" />,
    route: Route,
  },
  {
    id: 162,
    path: routes.Horizontal,
    name: "layout-horizontal",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 163,
    path: routes.Detached,
    name: "layout-detached",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 164,
    path: routes.Modern,
    name: "layout-modern",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 165,
    path: routes.TwoColumn,
    name: "layout-two-column",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 166,
    path: routes.Hovered,
    name: "layout-hovered",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 167,
    path: routes.Boxed,
    name: "layout-boxed",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 168,
    path: routes.RTL,
    name: "layout-rtl",
    element: <LayoutDemo />,
    route: Route,
  },
  {
    id: 169,
    path: routes.Dark,
    name: "layout-dark",
    element: <LayoutDemo />,
    route: Route,
  },

  {
    id: 1000,
    path: routes.crmdashboard,
    name: "crmdashboard",
    element: <CRMDashboard />,
    route: Route,
  },
  {
    id: 1001,
    path: routes.crmcustomers,
    name: "crmcustomers",
    element: <CRMCustomers />,
    route: Route,
  },
  {
    id: 1003,
    path: routes.crmcontacts,
    name: "crmcontacts",
    element: <CRMContacts />,
    route: Route,
  },

  {
    id: 1004,
    path: routes.crminvoices,
    name: "crminvoices",
    element: <CRMInvoices />,
    route: Route,
  },
  {
    id: 1005,
    path: routes.crmtasks,
    name: "crmtasks",
    element: <CRMTasks />,
    route: Route,
  },
  {
    id: 1006,
    path: routes.crmcreatenewestimate,
    name: "crmcreatenewestimate",
    element: <CreateNewEstimate />,
    route: Route,
  },
  {
    id: 1007,
    path: routes.crmestimates,
    name: "crmestimates",
    element: <Estimates />,
    route: Route,
  },
  {
    id: 1008,
    path: routes.crmsalesproposals,
    name: "crmsalesproposals",
    element: <Proposals />,
    route: Route,
  },
  {
    id: 1009,
    path: routes.crmcreateproposal,
    name: "crmcreateproposal",
    element: <CreateProposalForm />,
    route: Route,
  },
  {
    id: 1010,
    path: routes.crmeditproposal,
    name: "crmeditproposal",
    element: <EditProposalForm />,
    route: Route,
  },
  {
    id: 1011,
    path: routes.crmviewproposal,
    name: "crmviewproposal",
    element: <ViewProposal />,
    route: Route,
  },
  {
    id: 1012,
    path: routes.crmviewestimate,
    name: "crmviewestimate",
    element: <ViewEstimate />,
    route: Route,
  },
  {
    id: 1013,
    path: routes.crmeditestimate,
    name: "crmeditestimate",
    element: <EditEstimate />,
    route: Route,
  },
  {
    id: 1014,
    path: routes.crmnewinvoice,
    name: "crmnewinvoice",
    element: <NewInvoice />,
    route: Route,
  },
  {
    id: 1015,
    path: routes.crmeditinvoice,
    name: "crmeditinvoice",
    element: <Editinvoice />,
    route: Route,
  },
  {
    id: 1016,
    path: routes.crmexpenses,
    name: "crmexpenses",
    element: <CRMExpenses />,
    route: Route,
  },
  {
    id: 1017,
    path: routes.crmproposalinfo,
    name: "crmproposalinfo",
    element: <ProposalInfo />,
    route: Route,
  },
  {
    id: 1018,
    path: routes.crmestimateinfo,
    name: "crmestimateinfo",
    element: <EstimateInfo />,
    route: Route,
  },
  {
    id: 1019,
    path: routes.crmexpenseinfo,
    name: "crmexpenseinfo",
    element: <ExpenseInfo />,
    route: Route,
  },

  {
    id: 1020,
    path: routes.crmpayments,
    name: "crmpayments",
    element: <Payments />,
    route: Route,
  },
  {
    id: 1021,
    path: routes.crmcreditnotes,
    name: "crmcreditnotes",
    element: <CreditNotes />,
    route: Route,
  },
  {
    id: 1022,
    path: routes.crmnewcreditnote,
    name: "crmnewcreditnote",
    element: <NewCreditNote />,
    route: Route,
  },
  {
    id: 1023,
    path: routes.crmcreditnoteinfo,
    name: "crmcreditnoteinfo",
    element: <CreditNoteInfo />,
    route: Route,
  },
  {
    id: 1024,
    path: routes.crmviewpayments,
    name: "crmviewpayments",
    element: <ViewPayments />,
    route: Route,
  },
  {
    id: 1025,
    path: routes.crmleads,
    name: "crmleads",
    element: <Leads />,
    route: Route,
  },
  {
    id: 1026,
    path: routes.crmtickets,
    name: "crmtickets",
    element: <CRMTickets />,
    route: Route,
  },
  {
    id: 1027,
    path: routes.crmviewleads,
    name: "crmviewleads",
    element: <ViewLeads />,
    route: Route,
  },
  {
    id: 1028,
    path: routes.crmcustomerinfo,
    name: "crmcustomerinfo",
    element: <CustomerInfo />,
    route: Route,
  },
  {
    id: 1029,
    path: routes.crmnewticket,
    name: "crmnewticket",
    element: <NewTicket />,
    route: Route,
  },
  {
    id: 1029,
    path: routes.crmprojects,
    name: "crmprojects",
    element: <CRMProjects />,
    route: Route,
  },
  {
    id: 1030,
    path: routes.crmproducts,
    name: "crmproducts",
    element: <CRMProducts />,
    route: Route,
  },
  {
    id: 1031,
    path: routes.crmviewinvoice,
    name: "crmviewinvoice",
    element: <ViewInvoice />,
    route: Route,
  },

  {
    id: 1032,
    path: routes.crmeditexpenses,
    name: "crmeditexpenses",
    element: <EditExpense />,
    route: Route,
  },

  {
    id: 1033,
    path: routes.projectView,
    name: "projectView",
    element: <ProjectView />,
    route: Route,
  },
  {
    id: 1034,
    path: routes.crmcreditnoteedit,
    name: "crmcreditnoteedit",
    element: <EditCreditNote />,
    route: Route,
  },

  {
    id: 1035,
    path: routes.Add,
    name: "Add",
    element: <Add />,
    route: Route,
  },
  {
    id: 1036,
    path: routes.View,
    name: "View",
    element: <View />,
    route: Route,
  },
  {
    id: 1037,
    path: routes.Update,
    name: "Update",
    element: <Update />,
    route: Route,
  },
  {
    id: 1037,
    path: routes.reports,
    name: "reports",
    element: <Reports />,
    route: Route,
  },
  {
    id: 1038,
    path: routes.crmnotifications,
    name: "crmnotifications",
    element: <Notify />,
    route: Route,
  },
  {
    id: 1039,
    path: routes.queries,
    name: "queries",
    element: <SqlQuery />,
    route: Route,
  },
  {
    id: 1040,
    path: routes.campaign,
    name: "campaign",
    element: <Campaign />,
    route: Route,
  },
  {
    id: 1041,
    path: routes.crmmessagehub,
    name: "crmmessagehub",
    element: <MessageHub />,
    route: Route,
  },
];

export const posRoutes = [];

export const pagesRoute = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  {
    id: 1,
    path: routes.signinTwo,
    name: "signinTwo",
    element: <SigninTwo />,
    route: Route,
  },
  {
    id: 1,
    path: routes.singinThree,
    name: "singinThree",
    element: <SigninThree />,
    route: Route,
  },
  {
    id: 7,
    path: routes.forgotPassword,
    name: "forgotPassword",
    element: <Forgotpassword />,
    route: Route,
  },
];
